import { getAuth } from "firebase/auth";
import Freelance from "../models/Freelance.js";

const GET_FREELANCE_POSTS_URL = "https://europe-west3-hyper-e122e.cloudfunctions.net/get_freelance_posts";

class FreelanceService {
  static async getFreelancePosts() {
    try {
      const auth = getAuth();
      const currentUser = auth.currentUser;
      if (!currentUser) throw new Error("❌ Пользователь не авторизован");

      const token = await currentUser.getIdToken(true);
      if (!token) throw new Error("❌ Не удалось получить токен");

      const response = await fetch(GET_FREELANCE_POSTS_URL, {
        method: "GET",
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json",
        }
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`⚠️ Ошибка запроса: ${response.status} — ${errorText}`);
      }

      const data = await response.json();
      console.log("📥 Получены фриланс-посты:", data);

      // Исправление — бери .freelance из объекта:
      return (data.freelance || []).map(item => new Freelance(item));
    } catch (error) {
      console.error("❌ Не удалось загрузить фриланс-посты:");
      console.error("➡️", error.message);
      return [];
    }
  }
}

export default FreelanceService;